import { useEffect, useState } from "react";
import { AxiosResponse } from "axios";

import { SessionsAPI, type Session } from "../../session";
import { TherapistAPI, type HomeStats } from "../../therapist";

export type { HomeStats, PatientAgreementStats } from "../../therapist";

/** The home page's data for one therapist: their latest sessions and their stats. */
export function useHomeData(therapistId: string | undefined) {
  const [recentSessions, setRecentSessions] = useState<Session[]>([]);
  const [loadingSessions, setLoadingSessions] = useState(true);
  const [homeStats, setHomeStats] = useState<HomeStats | null>(null);

  useEffect(() => {
    if (!therapistId) return;

    setLoadingSessions(true);
    SessionsAPI.list_by_therapist(therapistId, { limit: 3 })
      .then((response: AxiosResponse<{ sessions: Session[] }>) => {
        setRecentSessions(response.data.sessions);
      })
      .catch((error: unknown) => {
        console.error("Error fetching recent sessions:", error);
      })
      .finally(() => {
        setLoadingSessions(false);
      });

    TherapistAPI.getHomeStats(therapistId)
      .then((res) => setHomeStats(res.data))
      .catch((err) => console.error("Error fetching home stats:", err));
  }, [therapistId]);

  return { recentSessions, loadingSessions, homeStats };
}
